"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROVIDER_SIGNUP_PATH = exports.MANAGE_PURCHASES_PATH = exports.GOOD_DETAILS_REVIEW_PATH = exports.GOOD_DETAILS_PREVIEW_PATH = exports.GOOD_DETAILS_DEMO_PATH = exports.GOOD_DETAILS_PATH = exports.DIRECTORY_PAGE_PATH = void 0;
var DIRECTORY_PAGE_PATH = 'products';
exports.DIRECTORY_PAGE_PATH = DIRECTORY_PAGE_PATH;
var GOOD_DETAILS_PATH = DIRECTORY_PAGE_PATH + "/:providerUrlToken/:goodNameUrlToken";
exports.GOOD_DETAILS_PATH = GOOD_DETAILS_PATH;
var GOOD_DETAILS_DEMO_PATH = GOOD_DETAILS_PATH + "/demo";
exports.GOOD_DETAILS_DEMO_PATH = GOOD_DETAILS_DEMO_PATH;
var GOOD_DETAILS_PREVIEW_PATH = GOOD_DETAILS_PATH + "/preview";
exports.GOOD_DETAILS_PREVIEW_PATH = GOOD_DETAILS_PREVIEW_PATH;
var GOOD_DETAILS_REVIEW_PATH = GOOD_DETAILS_PATH + "/review";
exports.GOOD_DETAILS_REVIEW_PATH = GOOD_DETAILS_REVIEW_PATH;
var MANAGE_PURCHASES_PATH = 'manage-purchases';
exports.MANAGE_PURCHASES_PATH = MANAGE_PURCHASES_PATH;
var PROVIDER_SIGNUP_PATH = 'provider-signup';
exports.PROVIDER_SIGNUP_PATH = PROVIDER_SIGNUP_PATH;